import React from "react";
import "./Developers.css"; // Add this file for custom styles

export default function Developers() {
  return (
    <div className="container mx-auto p-4">
      <div className="text-center text-white text-3xl mb-12 font-bold">
        خدمات اسپاد
      </div>
      <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-8">
        {/* Column 1 */}
        <a
          href="https://crm.spadserver.com/submitticket.php?step=2&deptid=8"
          className="developer-box bg-transparent rounded-[30px] hover-gradient transition duration-500 ease-in-out shadow-lg"
        >
                 <div className=" text-white p-6 md:p-8 flex flex-col items-center transition duration-500 ease-in-out wrapper-developers">
            <h3 className="text-[16px] md:text-[14px] font-bold mb-3">
              طراحی سایت
            </h3>
            <img
              src="images/cloud-service (4).png"
              alt="Icon 4"
              className="mb-2"
            />
            <p className="text-center border-t-[1px] border-[#4a5568] text-[14px] md:text-[13px] pt-4">
              در کدنویسی قالب طراحی سایت حرفه ای تمامی اصول اولیه سئو سایت مطابق
              با استانداردهای روز رعایت می‌شود.
            </p>
          </div>
        </a>

        {/* Column 2 */}
        <a
          href="https://spadserver.com/product/iran-virtual-server"
          className="developer-box bg-transparent rounded-[30px] hover-gradient shadow-lg"
        >
          <div className=" text-white p-6 md:p-8 flex flex-col items-center transition duration-500 ease-in-out wrapper-developers">
            <h3 className="text-[16px] md:text-[14px] font-bold mb-2">
              خدمات دیتاسنتر
            </h3>
            <img
              src="images/cloud-service (3).png"
              alt="Icon 3"
              className="mb-0"
            />
            <p className="text-center border-t-[1px] border-[#4a5568] text-[14px] md:text-[13px] pt-4">
              با خدمات هاست و سرور ما، وب‌سایت شما با سرعت بالا و امنیت بی‌نظیر
              به کاربران عرضه می‌شود. ما با ارائه فضای ذخیره‌سازی قوی، پشتیبانی
              24/7 و امکانات پیشرفته، تضمین می‌کنیم که وب‌سایت شما همیشه در
              دسترس و بدون مشکل باشد.
            </p>
          </div>
        </a>

        {/* Column 3 */}
        <a
          href="https://spadcowork.ir/"
          className="developer-box bg-transparent rounded-[30px] hover-gradient transition duration-500 ease-in-out shadow-lg"
        >
                <div className=" text-white p-6 md:p-8 flex flex-col items-center transition duration-500 ease-in-out wrapper-developers">
            <h3 className="text-[16px] md:text-[14px] font-bold mb-3">
              فضای کار اشتراکی
            </h3>
            <img
              src="images/cloud-service (2).png"
              alt="Icon 2"
              className="mb-2"
            />
            <p className="text-center border-t-[1px] border-[#4a5568] text-[14px] md:text-[13px] pt-4">
              فضای کار اشتراکی اسپاد محیطی ایده‌آل برای بهره‌وری و همکاری تیمی
              فراهم می‌کند. با امکانات مدرن و طراحی الهام‌بخش، این فضا به
              کسب‌وکارها و فریلنسرها کمک می‌کند تا با انعطاف‌پذیری بالا و
              هزینه‌ای مقرون‌به‌صرفه، پروژه‌های خود را پیش ببرند.
            </p>
          </div>
        </a>

        {/* Column 4 */}
        <a
          href="https://spadserver.com/domain"
          className="developer-box bg-transparent rounded-[30px] hover-gradient transition duration-500 ease-in-out shadow-lg"
        >
             <div className=" text-white p-6 md:p-8 flex flex-col items-center transition duration-500 ease-in-out wrapper-developers">
            <h3 className="text-[16px] md:text-[14px] font-bold mb-3">
              خدمات دامنه
            </h3>
            <img
              src="images/cloud-service (1).png"
              alt="Icon 1"
              className="mb-2"
            />
            <p className="text-center border-t-[1px] border-[#4a5568] text-[14px] md:text-[13px] pt-4">
              خدمات دامنه وب‌سایت اسپاد سرور به شما امکان می‌دهد تا با انتخاب
              نام‌های دامنه منحصربه‌فرد و مدیریتی ساده، هویت آنلاین خود را
              به‌سادگی ایجاد و حفظ کنید.
            </p>
          </div>
        </a>
      </div>
    </div>
  );
}
